import React from 'react';
import { TextField } from '@cimpress/react-components';

interface Props {
    note: string;
    onChangeNotes: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const noteSection = (props: Props) => {
    const { onChangeNotes, note } = props;

    // `TextField`'s types only model its `<input>` variants (`type` excludes `'textarea'` and `onChange`'s
    // event target is typed as `HTMLInputElement`), even though `type='textarea'` makes it render a real
    // `<textarea>` under the hood (same markup `TextArea` renders) -- casting to the shape that actually
    // matches that runtime behavior.
    const textFieldProps = {
        type: 'textarea',
        onChange: onChangeNotes,
        value: note,
        placeholder: 'Add notes',
        'data-testid': 'editor-information-notes-input',
    } as unknown as React.ComponentProps<typeof TextField>;

    return (
        <div className='information-panel__notes'>
            <TextField {...textFieldProps} />
        </div>
    );
};

export default noteSection;
